import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useState, useRef, useEffect } from 'react';
import "./styles.scss"
import ConsoleLocalStorage from "../../../storage/storage";
import PrimaryButton from "../../../util/Btns/PrimaryButton";
import forwardArrow from "../../../Assets/forward-arrow.svg"

const FTUGuide=({ showFTU, setShowModal, data })=> {
    
    const [currentSlide, setCurrentSlide] = useState(0)
    const customSlider = useRef();
    let settings = {
        dots: true,
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        // variableWidth: true,
        afterChange: current => {
            setCurrentSlide(current)
        }
    };

    const handleSubmit = () => {
        ConsoleLocalStorage.setFTU("false");
        setShowModal(false)
    }

    return (
        <>
            <div data-testid="ftu-guide" className="ftu-guide">
                <Slider {...settings} ref={customSlider} >
                    {data?.map((item, index) => {
                        return (
                            <div className="carousal-wrapper" key={index} >
                                {item?.patchName && <span className="patchName pl-3 pr-3 pt-1 pb-1 mtc-30 theme__font--medium">{item?.patchName}</span>}
                                <div className="img-wrapper">
                                    <img src={item.imgsrc} alt={item.title} />
                                </div>
                                <div className="text-wrapper">
                                    <div className="title font-size-22 theme__font--medium">{item.title}</div>
                                    <div className="desc font-size-12 theme__font--medium">{item.desc}</div>
                                </div>
                            </div>
                        )
                    })}
                </Slider>
                {currentSlide === data?.length - 1 ?
                    (
                        <div className="btn-wrapper">
                            <div className="carousal-btn c-pointer"  >
                            <PrimaryButton onClick={() => { handleSubmit() }}>Start Creating</PrimaryButton>
                                {/* <span className="denim-blue theme__font--medium">Start Creating</span> */}
                            </div>
                        </div>
                    ) :
                    (
                        <div className="carousal-btn-wrapper" >
                            <div className={`carousal-btn c-pointer ${ConsoleLocalStorage.getFTU()==='true'?'v-hide':''}`} onClick={() => { handleSubmit() }}>
                                <span className="theme__font--medium">Skip</span>
                            </div>
                            <div className="carousal-btn c-pointer" onClick={(e) => { customSlider.current.slickNext(); }}>
                                <span className="denim-blue theme__font--medium" >Next <img src={forwardArrow} className="mlc-5" alt="forward arrow"/></span>
                            </div>
                        </div>
                    )
                }
            </div>
        </>

    )
}

export default FTUGuide;